import { render } from "./VUEVersioneDMSEW.vue?vue&type=template&id=40b57225"
import script from "./VUEVersioneDMSEW.vue?vue&type=script&lang=js"
export * from "./VUEVersioneDMSEW.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__